<template>
  <div>
    <VueHtml2pdf
      :show-layout="true"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="2000"
      filename="export"
      :pdf-quality="4"
      :manual-pagination="false"
      pdf-orientation="landscape"
      pdf-content-width="2000"
      :html-to-pdf-options="htmlToPdfOptions"
      ref="html2Pdf"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="hasDownloaded($event)"
    >
      <section slot="pdf-content">
        <div class="flex justify-between">
          <div class="text-2xl font-extrabold">{{ title }}</div>
          <div v-if="pdfForm">{{ setDateFormat(pdfForm.from_date) }} - {{ setDateFormat(pdfForm.to_date) }}</div>
        </div>
        <slot></slot>
      </section>
    </VueHtml2pdf>
    <ModalProgress ref="modalProgress"/>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import ModalProgress from "@/components/modalProgress/ModalProgress";
import mixin from "@/views/mixin/mixin";

export default {
  name: "Export",
  mixins: [mixin],
  components: {
    ModalProgress,
    VueHtml2pdf
  },
  props: {
    title: {
      type: String
    },
    pdfForm: {
      type: Object
    }
  },
  data() {
    return {
      htmlToPdfOptions: {
        margin: 10,
        filename: this.title,
        image: {
          type: 'jpg',
          quality: 1
        },
        jsPDF: {
          format: 'a4',
          orientation: 'landscape'
        }
      }
    }
  },
  methods: {
    onProgress(e) {
      this.$emit('onProgress',e)
    },
    hasStartedGeneration(e) {
      this.$emit('hasStartedGeneration',e)
    },
    hasDownloaded(e) {
      this.$emit('hasDownloaded',e)
    },
    beforeDownload(e) {
      this.$emit('beforeDownload',e)
    },
    hasGenerated(e) {
      this.$emit('hasGenerated',e)
    },
  },
}
</script>

<style scoped>
  .vue-html2pdf {
    display: none;
  }
</style>
